import { useTranslation } from 'react-i18next'
import { useSWRConfig } from 'swr'

import { API_PATH_I18N_SUPPORTED, changeLanguage, languages } from '../../../libraries/i18n'
import GlobeIcon from '../../../assets/icons/globe.svg?react'
import type { Lang } from '../../../libraries/i18n/types'

const LangSwitcher = () => {
  const { i18n } = useTranslation()
  const { mutate } = useSWRConfig()
  const onChangeLang = (e: React.ChangeEvent<HTMLSelectElement>) => {
    changeLanguage(e.target.value as Lang)
    // Refetch all the data that needs to be translated
    API_PATH_I18N_SUPPORTED.forEach((path) => mutate(path))
  }
  return (
    <div className='inline-flex align-center'>
      <GlobeIcon className='w-6' />
      <select className='bg-transparent text-white' onChange={onChangeLang} value={i18n.language}>
        {languages.map(({ code, label }) => (
          <option key={code} value={code}>{label}</option>
        ))}
      </select>
    </div>
  )
}

export default LangSwitcher
